<template>
    <div>
        <div class="palletBank">
            <footer-title>费用说明</footer-title>
            <dl v-for="item in chargeDesc" :key="item.title">
                <dt>
                    <h2>{{item.title}}</h2>
                </dt>
                <dd>
                    <p>{{item.desc}}</p>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
import footerTitle from '_c/footerTitle.vue'
import {chargeDesc} from './dataList.js'
export default {
    components: { footerTitle },
    data(){
        return{
            chargeDesc
        }
    }

}
</script>

<style lang="scss" scoped>
@import './palletBank.scss';
</style>